import React, {useState} from 'react'
import styled from '@emotion/styled'

const Root = styled.div`
  font: 15px/1.7 raleway, sans-serif;
  color: #444;
`

const Action = styled.div`
  display: inline-block;
  cursor: pointer;
  color: #2d9831;
  font-weight: 600;
  font-size: 12px;
  text-decoration: none;
  border-bottom: 1px solid #c1dec2;
`

const GoodDescription = ({
  good: {
    description,
    trimmedDescription
  },
}) => {
  const longerDescriptionExists = description && description.length > trimmedDescription.length && trimmedDescription.slice(-3) === '...'
  const [showFullDescription, setShowFullDescription] = useState(false)

  return <Root>
    <div dangerouslySetInnerHTML={{__html: showFullDescription ? description : trimmedDescription}}/>
    {longerDescriptionExists && !showFullDescription && <Action onClick={() => setShowFullDescription(true)}>Развернуть целиком</Action>}
    {longerDescriptionExists && showFullDescription && <Action onClick={() => setShowFullDescription(false)}>Свернуть</Action>}
  </Root>
}

export default GoodDescription
